import { useCurrentWorkspace } from '@/context/current-workspace';
import { hasFeatureFlag } from '@/stores/auth';
import { useSampleWorkspace } from '@/utils/sample-workspace';
import * as styles from './index.css';

/**
 * The stripe shown at the top of the page. The color is configured by the user
 */
export function WorkspaceStripe() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  const showStripe =
    !(hasFeatureFlag('interactive_demo_workspace') || hasFeatureFlag('sample_workspace')) &&
    !isSampleWorkspace(workspace?.id);

  if (showStripe === false) {
    return null;
  }

  return <div className={styles.workspaceStripe} />;
}
